import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparison } from '../data/salesCopy';
export function ComparisonSection() {
  return <section className="w-full border-b border-line bg-paper" data-id="element-39" data-mp="3e699y0owxsv2">
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-5 sm:py-16 lg:py-20" data-id="element-40" data-mp="39dpm8awihhcj">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust sm:text-xs" data-id="element-41" data-mp="34g69jffgpcmp">
          Before vs. after
        </p>
        <h2 className="mt-3 max-w-2xl font-display text-2xl font-semibold leading-tight tracking-tight text-ink sm:mt-4 sm:text-4xl" data-id="element-42" data-mp="2zhcxlrftpton">
          Stop improvising. Start teaching from a system.
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-line bg-surface sm:mt-10" data-id="element-43" data-mp="2qgexvlcf48bv">
          <div className="hidden grid-cols-2 sm:grid" data-id="element-44" data-mp="2lid68c0xf0os">
            <div className="border-r border-line px-6 py-4 sm:px-8" data-id="element-45" data-mp="op1x98hhgmlm">
              <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-ink-muted" data-id="element-46" data-mp="om5wzdi5xlu0">
                Without TeachersKit
              </h3>
            </div>
            <div className="bg-ink px-6 py-4 sm:px-8" data-id="element-47" data-mp="3adjjaqjp68l5">
              <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-paper" data-id="element-48" data-mp="3eh7qh84f325v">
                With TeachersKit
              </h3>
            </div>
          </div>

          <ul className="divide-y divide-line sm:border-t sm:border-line" data-id="element-49" data-mp="30j9n0xrmwq55">
            {comparison.map(row => <li key={row.without} className="grid grid-cols-1 sm:grid-cols-2 sm:divide-x sm:divide-line" data-id="element-50" data-mp="3t5uj2bj21qf1">
                <div className="flex items-start gap-3 px-5 pb-2 pt-4 sm:px-8 sm:py-5" data-id="element-51" data-mp="1yhxlkb52qtb">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink-muted" aria-hidden="true" data-id="element-52" data-mp="3jf9kup7amnwn" />
                  <div data-id="element-53" data-mp="3odb357wwaj72">
                    <span className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-muted sm:hidden" data-id="element-54" data-mp="3ocsx5jkfkqly">
                      Without
                    </span>
                    <span className="text-[15px] leading-relaxed text-ink-muted" data-id="element-55" data-mp="kr3r3xykq5aq">{row.without}</span>
                  </div>
                </div>
                <div className="flex items-start gap-3 px-5 pb-4 pt-2 sm:px-8 sm:py-5" data-id="element-56" data-mp="pm6fs4keglew">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-rust" aria-hidden="true" data-id="element-57" data-mp="knbmu9spxgh2" />
                  <div data-id="element-58" data-mp="gm05ssnwu3kh">
                    <span className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.14em] text-rust sm:hidden" data-id="element-59" data-mp="gmrqv9jvsiwi">
                      With TeachersKit
                    </span>
                    <span className="text-[15px] font-medium leading-relaxed text-ink" data-id="element-60" data-mp="6voo83bazvv4">
                      {row.with}
                    </span>
                  </div>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}